import React, { lazy } from 'react';
import { getTypeformUrl } from '../utils/cookies';
export const HeroSection = () => {
  const handleScheduleTour = e => {
    e.preventDefault();
    window.location.href = getTypeformUrl();
  };
  return <>
      {/* Green Section — text content */}
      <section className="relative bg-[#1a2e1c] text-white overflow-hidden pt-24 pb-48 md:pt-28 md:pb-64" data-id="element-241">
        {/* Background texture */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(216,163,77,0.06)_0%,transparent_50%)] pointer-events-none" data-id="element-242"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_80%,rgba(216,163,77,0.04)_0%,transparent_50%)] pointer-events-none" data-id="element-243"></div>

        <div className="container mx-auto px-4 md:px-8 relative z-10" data-id="element-244">
          <div className="max-w-6xl mx-auto text-center" data-id="element-245">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-white/20 bg-white/10 backdrop-blur-sm mb-8 md:mb-10" data-id="element-246">
              <span className="text-[#d8a34d] font-bold text-sm" data-id="element-247">New</span>
              <span className="text-white/90 text-sm md:text-base" data-id="element-248">
                For Indian American Investors
              </span>
            </div>

            {/* Heading */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-display font-bold text-white leading-[1.1] mb-6 md:mb-8 tracking-tight" data-id="element-249">
              Dubai's Property Market Is Delivering{' '}
              <span className="text-[#d8a34d]" data-id="element-250">
                15–20% Annual Capital Growth
              </span>{' '}
              + Rental Yields
            </h1>

            {/* Description */}
            <p className="text-white/70 text-lg md:text-xl lg:text-2xl font-light leading-relaxed max-w-2xl mx-auto" data-id="element-251">
              Discover how global investors are entering one of the world's
              fastest growing real estate markets
            </p>
          </div>
        </div>
      </section>

      {/* White Section — video overlaps into green, then CTA below */}
      <section className="relative pb-10 md:pb-14" data-id="element-252">
        <div className="container mx-auto px-4 md:px-8" data-id="element-253">
          <div className="max-w-6xl mx-auto text-center" data-id="element-254">
            {/* Video — pulled up into the green zone */}
            <div className="-mt-36 md:-mt-48 mb-10 md:mb-14 relative z-10" data-id="element-255">
              <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.3)] border border-gray-200 bg-white p-1.5 md:p-2" data-id="element-256">
                <div style={{
                position: 'relative',
                paddingTop: '56.25%'
              }} className="rounded-xl overflow-hidden bg-black" data-id="element-257">
                  <iframe src="https://iframe.mediadelivery.net/embed/478913/fd1a8808-bcaf-47a9-8d5f-ff56fe812c5d?autoplay=true&loop=false&muted=false&preload=true&responsive=true" loading="lazy" style={{
                  border: 0,
                  position: 'absolute',
                  top: 0,
                  height: '100%',
                  width: '100%'
                }} allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowFullScreen={true} data-id="element-258"></iframe>
                </div>
              </div>
            </div>

            {/* Primary CTA */}
            <a href="#" onClick={e => {
            e.preventDefault();
            window.location.href = getTypeformUrl();
          }} className="btn-gold px-10 py-5 md:px-14 md:py-6 rounded-lg font-bold text-lg md:text-xl inline-block shadow-2xl animate-pulse-slow" data-id="element-259">
              Book a Free Strategy Call
            </a>
          </div>
        </div>
      </section>
    </>;
};